export const environment = {
  production: true,
  apiVersion: '1.15',
  apiUrl: '',
  baseUrl: '',
  version: 'local',
  ssr: true // Todo do we need this?
};
